import React from 'react';
import '../../App.scss';
import { updateState } from "../StateHelper";
import {resolveEnum, WAREHOUSE_STOCK_TYPES} from '../../Constants';
import { Button, Table, Modal } from 'react-bootstrap';
import AuthorizedPage from '../../component/AuthorizedPage';
import ProductItemApi from '../../api/ProductItemApi';
import QuickFilterButton from '../../component/QuickFilterButton';
import { Role } from '../../domain/Role';
import If from '../../component/If';

const initialState = {
  productItemsRaw: [] as any[],
  productItems: [] as any[],
  showProductItemStockUpdateModal: false,
  selectedProductItem: {} as any,
  selectedProductItemStockHistory: {} as any,
  stockHistoryData: [] as any[],
  packagingGroups: [] as any[],
  selectedPackagingGroup: "1500 GRAM",
  selectedWarehouseStockType: "",
  selectedWarehouse: "",
  showStockHistoryModal: false,
  isLoading: false,
  countedStocks: {} as any, // ✅ yeni eklendi
  page: 0,
  totalPages: 0,
  search: "",
  pageSize: 50,
};

const PAGE_SIZE_OPTIONS = [20, 50, 100, 200];

class StockManagement extends React.Component<any, any> {
  searchTimer: any;

  constructor(props: any) {
    super(props);
    this.state = initialState;

    this.renderProductItemStockUpdateModal = this.renderProductItemStockUpdateModal.bind(this);
    this.renderStockHistoryModal = this.renderStockHistoryModal.bind(this);
    this.showStockHistory = this.showStockHistory.bind(this);
    this.saveCountedStocks = this.saveCountedStocks.bind(this); // ✅ yeni
  }

  componentDidMount() {
    this.init();
    this.loadPackagingGroups();
  }

  init() {
    this.loadProductItems("","","");
  }

  async loadProductItems(packagingGroup: any, warehouseStockType:any, warehouse:any, page:number = this.state.page, search:string = this.state.search) {
    updateState(this, "isLoading", true);
    const response = await ProductItemApi.listFilteredPaged(packagingGroup, warehouseStockType, warehouse, false, search, page, this.state.pageSize);
    if (response.success && response.data) {
      updateState(this, "productItems", response.data.content || []);
      this.setState({ totalPages: response.data.totalPages || 0, page: response.data.number || 0 });
    }
    updateState(this, "isLoading", false);
  }

  gotoPage = (page:number, searchOverride?:string) => {
    const search = searchOverride !== undefined ? searchOverride : this.state.search;
    const type = this.state.selectedWarehouseStockType === "Tümü" ? "" : this.state.selectedWarehouseStockType;
    const warehouse = this.state.selectedWarehouse === "Tümü" ? "" : this.state.selectedWarehouse;
    this.loadProductItems(this.state.selectedPackagingGroup, type, warehouse, page, search);
  };

  onSearchChange = (value:string) => {
    this.setState({ search: value });
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => this.gotoPage(0, value), 350);
  };

  onPageSizeChange = (size:number) => {
    this.setState({ pageSize: size }, () => this.gotoPage(0));
  };

  renderPagination = () => {
    const { page, totalPages, pageSize } = this.state;
    return (
      <div className="d-flex justify-content-center align-items-center mt-3 mb-3">
        <Button size="sm" variant="outline-secondary" className="me-3" disabled={page <= 0} onClick={() => this.gotoPage(page - 1)}>← Önceki</Button>
        <span>Sayfa {totalPages === 0 ? 0 : page + 1} / {totalPages}</span>
        <Button size="sm" variant="outline-secondary" className="ms-3" disabled={page >= totalPages - 1} onClick={() => this.gotoPage(page + 1)}>Sonraki →</Button>
        <select
          className="form-select form-select-sm ms-4"
          style={{ width: "auto" }}
          value={pageSize}
          onChange={(e) => this.onPageSizeChange(Number(e.target.value))}
        >
          {PAGE_SIZE_OPTIONS.map((n) => (
            <option key={n} value={n}>{n} / sayfa</option>
          ))}
        </select>
      </div>
    );
  };

  async loadPackagingGroups() {
    const response = await ProductItemApi.listPackagingGroups();
    if (response.success) {
      updateState(this, "packagingGroups", response.data);
    }
  }

  async loadWarehouseStockTypes(){
      let response = await ProductItemApi.listWarehouseStockTypes();
      if (response.success) {
          const typesWithAll = ["Tümü", ...WAREHOUSE_STOCK_TYPES.map(type => type.value)];
          updateState(this, "warehouseStockTypes", typesWithAll);
      }
  }

  async showStockHistory(selected: any, warehouse?: any) {
    updateState(this, "selectedProductItemStockHistory", selected);
    const filters = { productItemId: selected.id, warehouseId: warehouse };
    const response = await ProductItemApi.listStockHistory(filters);
    if (response.success) {
      updateState(this, "stockHistoryData", response.data);
      updateState(this, "showStockHistoryModal", true);
    }
  }

  async onPackagingGroupChange(selectedGroup: any) {
    updateState(this, "selectedPackagingGroup", selectedGroup);
    this.loadProductItems(selectedGroup, this.state.selectedWarehouseStockType, this.state.selectedWarehouse, 0);
  }

  async onWarehouseStockTypeChange(selectedType: string) {
      selectedType = WAREHOUSE_STOCK_TYPES.find(item => item.value === selectedType)?.key || "";
      updateState(this, "selectedWarehouseStockType", selectedType);
      const backendValue = selectedType === "Tümü" ? "" : selectedType;
      this.loadProductItems(this.state.selectedPackagingGroup, backendValue, this.state.selectedWarehouse, 0);
  }

  async onWarehouseChange(selectedWarehouse: string) {
      updateState(this, "selectedWarehouse", selectedWarehouse);
      const backendValue = selectedWarehouse === "Tümü" ? "" : selectedWarehouse;
      this.loadProductItems(this.state.selectedPackagingGroup, this.state.selectedWarehouseStockType, backendValue, 0);
  }

  renderStockHistoryTable = () => {
    return (
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Aksiyon</th>
            <th>Değişen Adet</th>
            <th>Değişim (Adet)</th>
            <th>Depo</th>
            <th>Tarih</th>
          </tr>
        </thead>
        <tbody>
          {this.state.stockHistoryData.map((item: any) => (
            <tr key={item.createdAt + item.productItemId}>
              <td>{item.action?.label || "-"} {item.orderId && `#(${item.orderId})`}</td>
              <td>
                {item.quantityChange ?? 0}
                <If value={this.state.selectedProductItemStockHistory?.quantityInBox}>
                  <br />[{Math.floor((item.quantityChange ?? 0) / (this.state.selectedProductItemStockHistory.quantityInBox ?? 1))} Koli]
                </If>
              </td>
              <td>{(item.quantityAfterChange ?? 0) - (item.quantityChange ?? 0)} to {item.quantityAfterChange ?? 0}</td>
              <td>{item.warehouseId ? item.warehouseId: '-'}</td>
              <td>{item.createdAt ? new Intl.DateTimeFormat('tr-TR').format(new Date(item.createdAt)) : '-'}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    );
  };

  renderStockHistoryModal = () => (
    <Modal
      size="lg"
      autoFocus
      show={this.state.showStockHistoryModal}
      onHide={() => updateState(this, "showStockHistoryModal", false)}
      dialogClassName="modal-70w"
    >
      <Modal.Header closeButton>
        <Modal.Title>Stok Hareketleri</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {this.renderStockHistoryTable()}
      </Modal.Body>
    </Modal>
  );

  renderProductItemStockUpdateModal = () => {
    const { id, stocks } = this.state.selectedProductItem || {};
    if (!id) return null;

    return (
      <Modal
        size="lg"
        autoFocus
        show={this.state.showProductItemStockUpdateModal}
        onHide={() => updateState(this, "showProductItemStockUpdateModal", false)}
        dialogClassName="modal-90w"
      >
        <Modal.Header closeButton>
          <Modal.Title>Mal Sayım Stok Düzenleme</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p style={{ color: 'red' }}>
            Mal sayım sonrası girilen adetler mevcut stokları günceller. Emin olmadığınız stoklar için giriş yapmayınız!
          </p>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Depo</th>
                <th>Stoklama Şekli</th>
                <th>Mevcut Adet</th>
                <th>Sayım ile Düzeltilmiş Yeni Adet</th>
              </tr>
            </thead>
            <tbody>
              {stocks?.map((it: any) => (
                <tr key={it.warehouseId}>
                  <td>DEPO-{it.warehouseId}</td>
                  <td>{it.packagingUnitTypeAmount} {resolveEnum(it.packagingUnitType)} {resolveEnum(it.packagingType)}</td>
                  <td>{it.quantity ?? 0}<br />[{it.boxQuantity} Koli]</td>
                  <td>
                    <input
                      type="number"
                      style={{ width: "80px" }}
                      defaultValue={it.quantity || 0}
                      onChange={(e) => {
                        const newValue = parseInt(e.target.value) || 0;
                        this.setState((prev: any) => ({
                          countedStocks: {
                            ...prev.countedStocks,
                            [it.id]: newValue
                          }
                        }));
                      }}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => updateState(this, "showProductItemStockUpdateModal", false)}
          >
            İptal
          </Button>
          <Button
            variant="primary"
            onClick={() => this.saveCountedStocks()}
          >
            Kaydet
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  async saveCountedStocks() {
    const { selectedProductItem, countedStocks } = this.state;
    const bulkPayload = {
      updatedStocks: Object.entries(countedStocks).map(([id, quantity]) => ({
        id: Number(id),
        quantity: Number(quantity),
        notes: "" // istersen kullanıcı not girebilir, şimdilik boş
      }))
    };

    const response = await ProductItemApi.updateProductItemPoolStockBulk(bulkPayload);


    if (response.success) {
      this.init();
      updateState(this, "showProductItemStockUpdateModal", false);
    }
  }

  renderProductItemTableRows = (productItems: any) => {
    return productItems.map((it: any) => (
      <tr key={it.id}>
        <td>{it.stockCode}</td>
        <td>{it.name}</td>
        <td>{it.barcode}</td>
        <td>{it.packagingUnitTypeAmount} {resolveEnum(it.packagingUnitType)} {resolveEnum(it.packagingType)}</td>
        <td>
          {Array.isArray(it.stocks) && it.stocks.length > 0 ? (
            it.stocks.map((stock: any, idx: number) => (
              <Button
                key={stock.warehouseId ?? idx}
                size="sm"
                variant="link"
                onClick={() => this.showStockHistory(it, stock.warehouseId)}
              >
                <span style={{ color: 'black', fontWeight: 'bold' }}>DEPO-{idx + 1}:</span>{' '}
                <span style={{ color: 'blue' }}>{stock.quantity ?? 0}</span>
              </Button>
            ))
          ) : 'Stok bilgisi yok'}
        </td>
        <td>{it.totalStockQuantity ?? 0}</td>
        <td>
          <Button
            size="sm"
            variant="outline-success"
            onClick={() => {
              updateState(this, "selectedProductItem", it);
              updateState(this, "showProductItemStockUpdateModal", true);
            }}
          >
            Mal Sayım
          </Button>
        </td>
      </tr>
    ));
  };

  renderProductItemTable = () => (
    <Table striped bordered hover>
      <thead>
        <tr>
          <th>Stok Kodu</th>
          <th>Ürün Adı</th>
          <th>Barkod</th>
          <th>Paketleme</th>
          <th>Depo Stok</th>
          <th>Toplam Stok</th>
          <th>İşlem</th>
        </tr>
      </thead>
      <tbody>
        {this.renderProductItemTableRows(this.state.productItems)}
      </tbody>
    </Table>
  );

  render() {
    return (
      <AuthorizedPage role={Role.WAREHOUSE_ADMIN} isLoading={this.state.isLoading}>
        {this.renderProductItemStockUpdateModal()}
        {this.renderStockHistoryModal()}

        <div className="centered-95-percent">
          <div style={{ paddingBottom: "15px", paddingTop: "15px" }}>
          <h4>Stok Yönetimi</h4>
            <div className="search-container">
              <input
                type="text"
                placeholder="Ara"
                value={this.state.search}
                onChange={(e) => this.onSearchChange(e.target.value)}
                className="search-input"
              />
              <div className="search-icon"></div>
            </div>
          </div>
          <div className="row" style={{ marginBottom: "10px" }}>
            <QuickFilterButton
              selected={this.state.selectedPackagingGroup}
              onSelect={(event: any) => this.onPackagingGroupChange(event)}
              items={this.state.packagingGroups}
            />
          </div>
          {this.renderProductItemTable()}
          {this.renderPagination()}
        </div>
      </AuthorizedPage>
    );
  }
}

export default StockManagement;
